import { MatDialog } from '@angular/material/dialog';
import { Observable, map, tap } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

import { AlertService } from '../../../core/services';
import { BugReportCreateResponse } from '../../../core/models';
import { BugReportDialogComponent } from './bug-report-dialog.component';

/**
 * Open "report a problem" and report the outcome, for every entry point
 * (topbar bug icon, customer bug-report list, …). One place so the dialog
 * config and the success / partial-success messaging can't drift apart.
 *
 * Emits the create response when a report was filed, or null when the user
 * cancelled — callers that need to refresh a list can react to the former.
 */
export function openBugReportDialog(
  dialog: MatDialog,
  alert: AlertService,
  translate: TranslateService,
): Observable<BugReportCreateResponse | null> {
  return dialog.open(BugReportDialogComponent, {
    panelClass: 'bug-report-dialog-panel',
    autoFocus: 'first-tabbable',
    restoreFocus: true,
    disableClose: true,
  }).afterClosed().pipe(
    map((response: BugReportCreateResponse | undefined) => response ?? null),
    tap(response => {
      if (!response) return;
      const photosFailed = response.photosFailed?.length ?? 0;
      if (photosFailed > 0) {
        // The report itself was created — only some screenshots didn't make it.
        alert.showWarning(translate.instant('BUG_REPORT_DIALOG.SUBMIT_SUCCESS_PARTIAL', { count: photosFailed }));
      } else {
        alert.showSuccess(translate.instant('BUG_REPORT_DIALOG.SUBMIT_SUCCESS'));
      }
    }),
  );
}
